import React from 'react';
import Logo from 'common/components/header/Logo';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core';

import FooterSection from 'common/components/footer/FooterSection';
import FooterSocialMediaSection from 'common/components/footer/FooterSocialMediaSection';
import {
  organizationSectionData,
  gettingStartedSectionData,
  learnSectionData,
  moreSectionData,
} from 'common/components/footer/utils/footerData';
import FooterInfo from 'common/components/footer/FooterInfo';

interface IFooterProps {
  RouteLink: React.ComponentType<any>;
}

const Footer: React.FC<IFooterProps> = ({ RouteLink }) => {
  const classes = useStyles();
  return (
    <footer>
      <Box
        position="relative"
        boxShadow="rgb(0 0 0 / 15%) 0px -1.5px 3px"
        borderTop="1px solid rgb(0 0 0 / 0%)"
      >
        <Container maxWidth="xl">
          <Box position="absolute">
            <Grid container className={classes.root}>
              <Grid item xs={12} xl="auto">
                <Box px={4}>
                  <Logo />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl="auto">
                <FooterSection
                  label="Learn"
                  footerData={learnSectionData}
                  RouteLink={RouteLink}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6} lg={3} xl="auto">
                <FooterSection
                  label="Getting Started"
                  footerData={gettingStartedSectionData}
                  RouteLink={RouteLink}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl="auto">
                <FooterSection
                  label="More"
                  footerData={moreSectionData}
                  RouteLink={RouteLink}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl="auto">
                <FooterSection
                  label="Organization"
                  footerData={organizationSectionData}
                  RouteLink={RouteLink}
                />
                <Box mt={4}>
                  <FooterSocialMediaSection />
                </Box>
              </Grid>
            </Grid>
            <FooterInfo termsOfServiceLink="/terms-of-service/"/>
          </Box>
        </Container>
      </Box>
    </footer>
  );
};

export default Footer;

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12),
    rowGap: `${theme.spacing(4)}px`,
    '& .MuiListItemIcon-root': {
      minWidth: theme.spacing(7.5),
    },
    '& .MuiListItem-root': {
      paddingTop: theme.spacing(1),
      paddingBottom: 0,
    },
  },
}));
